import { createWfsWmsLayerObject } from './wfsImageLayer';
import { createWfsLayerObject } from './wfsVectorLayer';
import { CONTENT_TYPE_ID } from '../../../../constants';

export const createWfsLayer = function (store, layerData, extent, filterList, highQuality, alwaysCreateWfsLayer) {
    const filters = filterList;
    // Determine if we need to hide the polygon fill of a WFS layer
    // If so we will not create the wfswms layer but only the WFS layer
    // we will create this WFS layer with an extra parameter to indicate that
    // no fill is required. We will only do so when alwaysCreateWfsLayer is false.
    // When alwaysCreateWfsLayer is true this means we are creating an extra WFS layer for text information
    const hidePolygonFill = store.getters.getLayerhidePolygonFillById(layerData.customId);
    const hideFill = (hidePolygonFill && !alwaysCreateWfsLayer);

    const wfsWmsLayerObject = (!hidePolygonFill &&
        !layerData.useCluster &&
        layerData.contentTypeId !== CONTENT_TYPE_ID.MEASUREMENT &&
        layerData?.graphicalLayerName?.length > 0 &&
        !alwaysCreateWfsLayer);

    if (wfsWmsLayerObject) {
        return createWfsWmsLayerObject(store, layerData, extent, filters, highQuality);
    } else {
        return createWfsLayerObject(store, layerData, hideFill);
    }
};
